import { gsap } from 'gsap/dist/gsap';
import Plyr from 'plyr';

export function videoLightboxes() {

  /**************************************************************
  -> Open/close video lightboxes
  **************************************************************/
  const openButtons = Array.from(Array.from(document.querySelectorAll('[data-button-lightbox-video]')))
  
  openButtons.forEach(button => {
    let video
    const index = button.dataset.index
    const lightbox = document.querySelector(`[data-lightbox-video][data-index="${index}"]`)
    const lightboxContainer = lightbox.querySelector('[data-container]')
    const close = lightbox.querySelector('[data-lightbox-close]')
    const videoElement = lightbox.querySelector('.video-container')

    video = new Plyr(videoElement)

    button.addEventListener('click', () => {
      
      document.body.style.overflow = 'hidden'
      gsap.to(lightbox, { opacity: 1, pointerEvents: 'all', delay: 0.3})
      gsap.to(lightboxContainer, { y: 0, delay: 0.3 })

      if (video) {
        setTimeout(() => {
          video.play()
        }, 500)
      }
      
      close.addEventListener('click', () => {
        document.body.style.overflow = 'initial'
        gsap.to(lightbox, { opacity: 0, pointerEvents: 'none' })
        gsap.to(lightboxContainer, { y: '25px' })
        video.pause()
      })
    })
  });

}


// WEBPACK FOOTER //
// ./scripts/animation/video-lightbox.js